import React from 'react';
import { Game } from '../Game';

import style from './OverflowSlider.css';

export const OverflowSlider = ({ gameCodes }) => (
    <div className={style.games}>
        {gameCodes.map(code =>
            <Game
                key={code}
                code={code}
                className={style.game}
            />
        )}
    </div>
);
